"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateConverter = void 0;
const enums_1 = require("../enums");
const dayjs_1 = __importDefault(require("dayjs"));
const relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
class DateConverter {
    static convertDate(value, format, tz) {
        dayjs_1.default.extend(relativeTime_1.default);
        dayjs_1.default.extend(utc_1.default);
        dayjs_1.default.extend(timezone_1.default);
        if (value && new Date(value)) {
            if (format === enums_1.DateFormats.DATE_AGO) {
                return (0, dayjs_1.default)(value).fromNow();
            }
            else {
                const customFormat = DateConverter.getFormat(format);
                if (tz) {
                    return dayjs_1.default.unix(value).tz(tz).format(customFormat);
                }
                else {
                    return (0, dayjs_1.default)(value).format(customFormat);
                }
            }
        }
        else {
            if (format === enums_1.DateFormats.TABLE_DATE) {
                return '-';
            }
            else {
                return 'Invalid Date';
            }
        }
    }
    /**
     * Get the moment date format types from our DateFormats enum type
     */
    static getFormat(format) {
        switch (format) {
            /**
             * Custom Date Pipes
             */
            case enums_1.DateFormats.TABLE_DATE:
                return 'MM/DD/YY';
            case enums_1.DateFormats.FORM_DATE_TIME:
                return 'MMMM D, Y, h:mm a';
            /**
             * Date & Time
             */
            case enums_1.DateFormats.FULL_DATE_TIME:
                return 'dddd, MMMM D, Y, h:mm:ss a z';
            case enums_1.DateFormats.LONG_DATE_TIME:
                return 'MMMM D, Y, h:mm:ss a z';
            case enums_1.DateFormats.MEDIUM_DATE_TIME:
                return 'MMM D, Y, h:mm:ss a';
            case enums_1.DateFormats.MEDIUM_DATE_SHORT_TIME:
                return 'MMM D, Y, h:mm a';
            case enums_1.DateFormats.SHORT_DATE_TIME:
                return 'M/D/YY, h:mm a';
            case enums_1.DateFormats.MINI_DATE_TIME:
                return 'M/D h:mm';
            case enums_1.DateFormats.MINI_DATE_MEDIUM_TIME:
                return 'MMM D h:mm:ss a';
            /**
             * Date
             */
            case enums_1.DateFormats.FULL_DATE:
                return 'dddd, MMMM D, Y';
            case enums_1.DateFormats.LONG_DATE:
                return 'MMMM D, Y';
            case enums_1.DateFormats.MEDIUM_DATE:
                return 'MMM D, Y';
            case enums_1.DateFormats.SHORT_DATE:
                return 'M/D/YY';
            case enums_1.DateFormats.MINI_DATE:
                return 'M/D';
            /**
             * Time
             */
            case enums_1.DateFormats.LONG_TIME:
                return 'h:mm:ss a z';
            case enums_1.DateFormats.MEDIUM_TIME:
                return 'h:mm:ss a';
            case enums_1.DateFormats.SHORT_TIME:
                return 'h:mm a';
            default:
                return format;
        }
    }
    /**
     * Transformer that takes a timestamp and converts it into a Date object
     * @param value
     **/
    static DateTransformer(value) {
        if (value && new Date(value)) {
            return new Date(value);
        }
        else {
            throw new Error('Invalid Date');
        }
    }
}
exports.DateConverter = DateConverter;
